'use client';

import { useEffect, useState } from 'react';
import { builder } from '@builder.io/sdk';
import { BUILDER_DATA_MODELS } from '@/hoc/withBuilderPageData';
import { PageAlert, PageAlertVariant } from './PageAlert';
import { logger } from '@/utils/logger';

interface SiteAlertData {
  isEnabled?: boolean;
  variant?: PageAlertVariant;
  headline?: string;
  body?: string;
}

export const SiteAlertBanner = () => {
  const [alertData, setAlertData] = useState<SiteAlertData | null>(null);

  useEffect(() => {
    let isMounted = true;

    const fetchAlert = async () => {
      try {
        const response = await builder.get(BUILDER_DATA_MODELS.siteAlert).toPromise();
        if (isMounted && response?.data?.isEnabled) {
          setAlertData(response.data);
        }
      } catch (error) {
        if (isMounted) {
          logger.error('Failed to fetch site alert', error);
        }
      }
    };

    fetchAlert();

    return () => {
      isMounted = false;
    };
  }, []);

  if (!alertData) return null;

  return (
    <div className="tc-container my-4">
      <PageAlert variant={alertData.variant} headline={alertData.headline} body={alertData.body} />
    </div>
  );
};
